// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Office model belongsTo relations 1`] = `
Array [
  "Team",
  "Location",
]
`;
